module.exports = __webpack_public_path__ + "img/y2.534d7372.png";